export default __webpack_public_path__ + "static/media/logo-light.dc63a060.png";